import React from "react";
import Button from "../ui/Button";
import GroupedTaskPicker from "./GroupedTaskPicker";

const BILLING_ASSIGNMENT_OPTIONS = [
  { value: "included", label: "Included in price" },
  { value: "extra", label: "Bill extra" },
  { value: "not_billable", label: "Not billable" },
  { value: "hide_from_project", label: "Hide from project" },
];

export default function LineItemAssignmentToolbar({
  selectedCount = 0,
  taskBundle,
  taskOverride = "",
  onTaskOverrideChange,
  billingOption = "included",
  onBillingOptionChange,
  onApply,
  onClearSelection,
  onNewTask,
  applySaving = false,
  projectId,
  size = "sm",
  className = "",
}) {
  if (selectedCount <= 0) return null;

  const textSize = size === "xs" ? "text-xs" : "text-sm";
  const disabledNoProject = !projectId;

  return (
    <div
      className={`flex flex-wrap items-center gap-3 mb-2 py-2 px-2 bg-gray-100 rounded ${textSize} ${className}`}
    >
      <span className="text-gray-600">{selectedCount} line item(s) selected</span>
      <span className="text-gray-600">Task</span>
      <GroupedTaskPicker
        bundle={taskBundle}
        value={taskOverride}
        onChange={onTaskOverrideChange}
        disabled={disabledNoProject || applySaving}
        placeholder={disabledNoProject ? "Set project first" : "Select task…"}
      />
      <Button
        type="button"
        variant="outline"
        size={size}
        onClick={onNewTask}
        disabled={disabledNoProject || applySaving}
        title={disabledNoProject ? "Set project first" : "Create a new task"}
      >
        + New task
      </Button>
      <span className="text-gray-600">Billing</span>
      <select
        value={billingOption}
        onChange={(e) => onBillingOptionChange?.(e.target.value)}
        disabled={applySaving}
        className="border rounded px-2 py-1 min-w-[160px]"
        title="Required"
      >
        {BILLING_ASSIGNMENT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <Button size={size} onClick={onApply} disabled={applySaving}>
        {applySaving ? "Applying…" : `Apply to selected (${selectedCount})`}
      </Button>
      <button
        type="button"
        onClick={onClearSelection}
        className="text-gray-600 hover:text-gray-800 underline"
      >
        Clear selection
      </button>
    </div>
  );
}
